import { Reveal, SectionHead } from "@/components/Reveal";

const STEPS = [
  { no: "01", title: "Describe the part", body: "Tell us what you need made and how it will be used." },
  { no: "02", title: "Share the requirements", body: "Include the material, estimated quantity, critical features, and requested timing." },
  { no: "03", title: "Start the conversation", body: "Discuss project suitability, documentation needs, and the appropriate way to share drawings or models." },
];

// K — Project inquiry process.
export const Process = () => (
  <section data-testid="process-section" className="on-light bg-[var(--sand)] py-24 sm:py-32">
    <div className="wrap">
      <SectionHead
        no="08"
        eyebrow="HOW TO START"
        title={<>Start with the details <span className="font-serif-i">that define the job.</span></>}
      />

      <div className="relative mt-14 grid gap-5 md:grid-cols-3">
        <div className="pointer-events-none absolute left-0 right-0 top-10 hidden h-px bg-[var(--line)] md:block" />
        {STEPS.map((s, i) => (
          <Reveal key={s.no} delay={i * 0.1}>
            <div className="relative h-full rounded-[0.75rem] border border-[var(--line)] bg-white p-7">
              <span className="font-mono text-[11px] tracking-[0.2em] text-[var(--blue)]">{s.no} /</span>
              <h3 className="mt-6 text-xl font-semibold tracking-[-0.02em] text-[var(--ink)]">{s.title}</h3>
              <p className="mt-3 text-[14.5px] leading-relaxed text-[var(--grey)] [text-wrap:pretty]">{s.body}</p>
            </div>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.3}>
        <button
          type="button"
          data-testid="process-discuss-button"
          className="btn btn-blue mt-10"
          onClick={() => { const el = document.getElementById("contact"); if (window.__lenis && el) window.__lenis.scrollTo(el, { offset: -90 }); else el?.scrollIntoView({ behavior: "smooth" }); }}
        >
          Discuss My Project
        </button>
      </Reveal>
    </div>
  </section>
);
